<template>
  <div class="feature-block" v-if="readyToRender">
    <h5>AGENCE ASSOCIÉE :</h5>

    <div v-if="check_access == false">
      <p v-if="agencyName != null">{{ agencyName }}</p>
      <p v-else>Aucune agence associée.</p>
    </div>
    
    <div v-else>
      <div class="form-group" style="display:flex;">
        <div style="width:100%; padding-right: 10px;">
          <custom-select :field="fields[0]" 
                        :value="fields[0].value" 
                        :field_idx="0" 
                        @field-updated="selectedAgency = $event.new_value.value">
          </custom-select>
        </div>
        <button class="btn btn-success" 
                style="margin-left: auto;max-height:37px;" 
                @click="submitManagerUpdateForm"
                v-if="!closedLead">Modifier</button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState, mapGetters} from "vuex"
import Select2 from "components/Form/Select2"
import CustomSelect from "components/Forms/Elements/Select"
import {camelToSnake} from 'utils/helpers'

export default {
  name:"LeadAgency",
  props:["current_lead"],

  data () {
    return {
      selectedAgency: null,
    }
  },

  components:{
    Select2,
    CustomSelect,
  },

  computed: {
    ...mapState(["agencies", "user"]),
    ...mapGetters("crm", ["is_fetching", "userGroups"]),

    readyToRender(){
      return this.current_lead != null && this.agencies.length > 0 && this.userGroups.length > 0 && this.user != null ? true : false
    },

    check_access()
    {
      var res = false
      if (this.user && this.user.me)
        _.each(this.user.me.roles, (role) => {
          if (role.name == 'green-number' || role.name == 'manager' || role.name == 'administrator' || role.name == 'super-administrator')
            res = true
        })
      var found = _.find(this.user.me.roles, role => role.name == "agency")
      if (!found && this.user.me.roles.length == 1)
        res = true
      return res
    },

    optionsList() {
      // Default option
      let defaultOption = _.assign({}, {
        id: null,
        text: "Aucune"
      })

      // Formatted user groups
      let userGroupsOptions = _.map(this.userGroups, (userGroup) => (
        {
          id: "user_group." + userGroup.id,
          text: userGroup.display_name
        }
      ))

      // Formatted agencies
      let agenciesOptions = _.map(this.agencies, (agency) => (
        {
          id: "agency." + agency.id,
          text: agency.name
        }
      ))

      return _.concat(defaultOption, userGroupsOptions, agenciesOptions)
    },

    fields() {
      let v = [
        {values:this.optionsList, multiple:false, placeholder:"", disabled:this.is_fetching, idx:0, required:false, value:this.selectedAgency, label:"Agence",type:"select"},
      ]
      return v
    },

    closedLead() {
      return 'closed' == this.current_lead.status
    },

    agencyName() {
      let leadableId = this.current_lead.leadable_id
      let leadableType = this.current_lead.leadable_type

      if ( !leadableId || !leadableType )
        return null
      
      let leadableTypeArray = leadableType.split("\\")

      if (leadableTypeArray.length != 3)
        return null

      let leadableIdentifier = camelToSnake(leadableTypeArray[2]) + "." + leadableId
      let correspondingOption = _.find(this.optionsList, o => o.id == leadableIdentifier)

      if (correspondingOption)
        return correspondingOption.text
      
      return null
    },
  },

  methods:{
    ...mapActions("crm", ["set_fetching_state", "update_lead_agency", "fetch_a_lead", "fetchCrmRelatedUserGroups", "updateLeadManager"]),

    submitManagerUpdateForm() {
      // Data preparation
      let leadable_id = null
      let leadable_type = null
      
      if (this.selectedAgency != null) {
        let leadableArray = this.selectedAgency.split(".")

        if (leadableArray.length != 2) {
          this.$store.state.crm.errors.push([{message: "Une erreur s'est produite, merci de rafraîchir la page avant de réessayer"}])

          return false
        }

        leadable_type = leadableArray[0]
        leadable_id = leadableArray[1]
      }
      
      // Endpoint call
      // console.log("ID: " + leadable_id + ", Type: " + leadable_type)
      this.updateLeadManager({
        lead_id: this.current_lead.id,
        params: {
          leadable_id,
          leadable_type
        }
      })
      .then(() => {
        this.set_fetching_state(true)
        this.fetch_a_lead(this.current_lead.id)
            .then(() => {
              this.set_fetching_state(false)
              this.init()
            })
      })
    },

    init() {
      // Selected agency
      this.selectedAgency = null

      if ( this.current_lead.leadable_type && this.current_lead.leadable_id ) {
        let leadableTypeArray = this.current_lead.leadable_type.split("\\")

        if ( leadableTypeArray.length == 3 )
          this.selectedAgency = camelToSnake(leadableTypeArray[2]) + "." + this.current_lead.leadable_id
      }
    },
  },

  mounted() {
    this.fetchCrmRelatedUserGroups()
    this.init()
  }
}
</script>

<style scoped lang="scss">
  .feature-block {
    margin-bottom: 20px;
  }

  h5 {
    color:#fb557a;
  }
</style>



// WEBPACK FOOTER //
// client/components/CRM/LeadAgency.vue